import { emailBaseApi } from "@/react/services/api";
import { HttpMethods } from "@/react/http";

const account = "PRODUCT_UPDATES";

export const sendEmailApi = emailBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getEmailTemplates: build.query({
      query: () => ({
        url: `templates?account=${account}`,
        method: HttpMethods.GET,
      }),
    }),
    sendEmail: build.mutation({
      query: (body) => ({
        url: `?account=${account}`,
        method: HttpMethods.POST,
        body: body,
      }),
    }),
  }),
});

export const { useGetEmailTemplatesQuery, useSendEmailMutation } = sendEmailApi;
